import styled from 'styled-components';

const Container = styled.div`
  border-radius: 50%;
  width: 16px;
  height: 16px;
  padding: 1px;
  border: ${({ theme }) => `solid 1px ${theme.configs.CTAButton.bgColor}`};
`;

const Dot = styled.div`
  border-radius: 50%;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.configs.CTAButton.bgColor};
`;

export { Container, Dot };
